<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow class="col-12 d-flex flex-column justify-content-center align-content-center">
      <div class="col-lg-3 col-5 d-flex justify-content-center align-self-center mb-5">
        <img id="logo-img" src="../assets/logo.svg">
      </div>
      <CCol lg="6" sm="12">
        <CCard class="mb-0">
          <CCardBody>
            <CForm @submit.prevent="handleSubmit">
              <h1>{{ $t('logIn') }}</h1>
              <p v-if="mode == 'LOGIN'" class="text-muted">{{ $t('signIn') }}</p>
              <p v-else class="text-muted">{{ $t('recoverPassword') }}</p>
              <!-- Username -->
              <CInput :placeholder="$t('email')" autocomplete="username email" v-model="username" :invalid-feedback="$t('invalidEmail')" :is-valid="validator">
                <template #prepend-content><CIcon name="cil-user"/></template>
              </CInput>
              <!-- Password -->
              <CInput v-if="mode != 'REQUEST-LINK'" :placeholder="$t('password')" type="password" autocomplete="curent-password" v-model="password" :invalid-feedback="$t('invalidPassword')" :is-valid="validator">
                <template #prepend-content><CIcon name="cil-lock-locked"/></template>
              </CInput>
              <!-- Description of forgot password -->
              <p v-else>{{$t("forgotPasswordDescription")}}</p>
              <!-- Token -->
              <CInput v-if="mode == 'RECOVER-PASSWORD'" :placeholder="$t('token')" v-model="token" :invalid-feedback="$t('invalidToken')" :is-valid="validator">
                <template #prepend-content><CIcon name="cil-file"/></template>
              </CInput>
              <CRow>
                <CCol col="6" class="text-left">
                  <!-- Forgot password -->
                  <CButton v-if="mode == 'LOGIN'" color="link" class="px-0" @click="mode = !requested ? 'REQUEST-LINK' : 'RECOVER-PASSWORD'">{{ $t('forgotPassword') }}</CButton>
                  <CButton v-else color="link" class="px-0" @click="mode = 'LOGIN'">< {{ $t('goBack') }}</CButton>
                </CCol>
                <!-- Confirm -->
                <CCol col="6" class="text-right">
                  <CSpinner v-if="loading" variant="success" small></CSpinner>
                  <div v-else>
                    <CButton v-if="mode == 'LOGIN'" color="primary" class="px-4" @click="loginClicked">{{ $t('logIn') }}</CButton>
                    <CButton v-else-if="mode == 'REQUEST-LINK'" color="primary" class="px-4" @click="sendEmailClicked">{{ $t('sendEmail') }}</CButton>
                    <CButton v-else color="primary" class="px-4" @click="changePasswordClicked">{{ $t('changePassword') }}</CButton>
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      username: '',
      password: '',
      token: '',
      loginError: false,
      requested: false,
      submitted: false,
      loading: false,
      mode: "LOGIN"
    }
  },
  computed:
  {
    ...mapState({ 
      alertType: state => state.alert.type,
      alertOutput: state => state.alert.output
    }),
    ...mapState('users', ['processTask']),
  },
  name: 'Login',
  methods: {
    ...mapActions('users', ['login']),
    ...mapActions('users', ['requestLinkPassword']),
    ...mapActions('users', ['resetPassword']),
    ...mapActions({
        clearAlert: 'alert/clear' 
    }),
    loginClicked: function(){
      this.submitted = true;

      const { username, password } = this;
      if (username && password) {
        this.loading = true;
        this.login({ username, password })
      }
    },
    validator(val) 
    {
      var result = undefined; // This is the default, in case the user hasn't submitted yet

      if(this.submitted && (!val || this.loginError))
      {
        result = false;
      }

      return result;
    },
    sendEmailClicked: function()
    {
      if(this.username)
      {
        this.loading = true;
        this.requested = true;
        this.requestLinkPassword(this.username);
      }
    },
    changePasswordClicked: function()
    {
      const { username, password, token } = this;
      if(username && password && token)
      {
        this.loading = true;
        this.resetPassword({username, password, token});
      }
    }
  },
  created: function()
  {
    this.clearAlert();
  },
  watch: 
  { 
    alertType: function()
    {
      this.loginError = this.alertType === "alert-danger";
    },
    alertOutput: function()
    {
      this.loginError = this.alertType === "alert-danger";
    },
    username: function()
    {
      this.loginError = false;
    },
    password: function()
    {
      this.loginError = false;
    },
    loginError: function(val)
    {
      if(val)
      {
        this.loading = false;
      }
    },
    processTask: function(val)
    {
      if(val != null)
      {
        if(this.mode == 'REQUEST-LINK')
        {
          var result = this.$i18n.t("requestLinkError");

          if(val == true)
          {
            result = this.$i18n.t("requestLinkSuccess");
            this.mode = 'RECOVER-PASSWORD';
          }

          this.loading = false;
        }
        else if(this.mode == 'RECOVER-PASSWORD')
        {
          if(val == false)
          {
            var result = this.$i18n.t("recoverPasswordError");
            this.loading = false;
          }
          else
          {
            result = this.$i18n.t("recoverPasswordSuccess");
            this.mode = 'LOGIN';
            this.loginClicked();
          }
        }

        alert(result);
      }
    }
  }
}
</script>

<style scoped>
#logo-img
{
  max-width: 50vw;
  max-height: 50vh;
}
</style>